var _a;
import { CardsEnum } from "./CardsEnum";
import { Alia, Amex, Carnet, Dinners, Discover, JCB, Mastercard, Visa, } from "../../assets/logos";
import { Cash, Transfer } from "../../assets/images/paymentMethods";
export var BRANDS_IMGS = (_a = {},
    _a[CardsEnum.visa] = Visa,
    _a[CardsEnum.amex] = Amex,
    _a[CardsEnum.american_express] = Amex,
    _a[CardsEnum.alia] = Alia,
    _a[CardsEnum.diners] = Dinners,
    _a[CardsEnum.discover] = Discover,
    _a[CardsEnum.mastercard] = Mastercard,
    _a[CardsEnum.master_card] = Mastercard,
    _a[CardsEnum.jcb] = JCB,
    _a[CardsEnum.transfer] = Transfer,
    _a[CardsEnum.cash] = Cash,
    _a[CardsEnum.carnet] = Carnet,
    _a);
